import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const SurveyBackground = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 401}
          height={props.height ?? 351}
          viewBox="0 0 401 351"
          fill="none"
        >
          <Path
            d="M401.009 350.657H31.7644V350.591C23.1273 350.591 15.305 347.02 9.66641 341.299C4.06043 335.612 0.572998 327.709 0.572998 318.98H0.507812V0.21875H40.4667V310.151H401.009V350.657ZM272.235 151.002H335.954C339.343 151.002 342.114 153.813 342.114 157.251V284.425C342.114 287.864 339.343 290.675 335.954 290.675H272.235C268.845 290.675 266.074 287.864 266.074 284.425V157.284C266.074 153.846 268.845 151.002 272.235 151.002ZM83.1633 73.1964H146.882C150.272 73.1964 153.042 76.0071 153.042 79.446V284.458C153.042 287.897 150.272 290.708 146.882 290.708H83.1633C79.7737 290.708 77.0033 287.897 77.0033 284.458V79.446C77.0033 76.0071 79.7737 73.1964 83.1633 73.1964ZM177.715 29.4164H241.402C244.791 29.4164 247.562 32.2271 247.562 35.666V284.458C247.562 287.897 244.791 290.708 241.402 290.708H177.715C174.326 290.708 171.555 287.897 171.555 284.458V35.666C171.555 32.2271 174.326 29.4164 177.715 29.4164Z"
            fill={props.color ?? '#FFFFFF'}
            fillOpacity="0.45"
          />
        </Svg>
      </View>
    );
  },
);

export { SurveyBackground };
